/* import { config, municipalityConfig } from '../config'; */
export const types= [
    {value: 'breeding', label: 'Breeding'},
    {value: 'sale', label: 'Sale'},
    {value: 'adoption', label: 'Adoption'},
    {value: 'lost', label: 'Lost'}
]
export const entities = [
    {value: 'FB', label: 'Federacija' }, 
    {value: 'RS', label: 'Republika Srpska' }, 
    {value: 'DB', label: 'Distrikt Brčko' }
];

export const cantons = [
    { value: '1', label: 'Unsko-sanski kanton' },
    { value: '2', label: 'Posavski kanton' },
    { value: '3', label: 'Tuzlanski kanton' },
    { value: '4', label: 'Zeničko-dobojski kanton' },
    { value: '5', label: 'Bosansko-podrinjski kanton Goražde' },
    { value: '6', label: 'Srednjobosanski kanton' },
    { value: '7', label: 'Hercegovačko-neretvanski kanton' },
    { value: '8', label: 'Zapadnohercegovački kanton' },
    { value: '9', label: 'Kanton Sarajevo' },
    { value: '10', label: 'Kanton 10' },
];

export const municipalities = [
    { "value": "5f0efec682066e35980108d1", "label": "Banovići" },
    { "value": "5f0f00cf82066e35980108d2", "label": "Banja Luka" }, 
    { "value": "5f0f022b82066e35980108d3", "label": "Berkovići" }, 
    { "value": "5f0f041a82066e35980108d4", "label": "Bihać" }, 
    { "value": "5f0f079682066e35980108d5", "label": "Bijeljina" }, 
    { "value": "5f0f0a2282066e35980108d6", "label": "Bileća" }, 
    { "value": "5f0f0ce182066e35980108d7", "label": "Bosanska Krupa" }, 
    { "value": "5f0f0f9c82066e35980108d8", "label": "Bosanski Petrovac" }, 
    { "value": "5f0f183982066e35980108d9", "label": "Bratunac" }, 
    { "value": "5f0f209b82066e35980108da", "label": "Breza" }, 
    { "value": "5f0f233882066e35980108db", "label": "Brod" }, 
    { "value": "5f0f258c82066e35980108dc", "label": "Bugojno" }, 
    { "value": "5f0f291782066e35980108dd", "label": "Busovača" }, 
    { "value": "5f0f2aaf82066e35980108de", "label": "Bužim" }, 
    { "value": "5f0f2bc782066e35980108df", "label": "Brčko" }, 
    { "value": "5f0f300882066e35980108e0", "label": "Cazin" }, 
    { "value": "5f0f372fe2177e37884ed880", "label": "Centar" }, 
    { "value": "5f0f3a49e2177e37884ed881", "label": "Čajniče" }, 
    { "value": "5f0f3e1ce2177e37884ed882", "label": "Čapljina" }, 
    { "value": "5f0f4117e2177e37884ed883", "label": "Čelić" }, 
    { "value": "5f0f4309e2177e37884ed884", "label": "Čelinac" }, 
    { "value": "5f0f4589e2177e37884ed885", "label": "Čitluk" }, 
    { "value": "5f0f47a4e2177e37884ed886", "label": "Derventa" }, 
    { "value": "5f0f4970e2177e37884ed887", "label": "Doboj" }, 
    { "value": "5f0f4da1e2177e37884ed888", "label": "Doboj-Istok" }, 
    { "value": "5f0f4f4ee2177e37884ed889", "label": "Doboj-Jug" }, 
    { "value": "5f0f52f5e2177e37884ed88a", "label": "Dobretići" }, 
    { "value": "5f0fe35fe2177e37884ed88c", "label": "Domoljevac-Šamac" }, 
    { "value": "5f0fe66be2177e37884ed88d", "label": "Donji Vakuf" }, 
    { "value": "5f0fe964e2177e37884ed88e", "label": "Donji Žabar" }, 
    { "value": "5f16e4b7c81dd03c240c5e56", "label": "Foča FBIH" }, 
    { "value": "5f16f58ac81dd03c240c5e57", "label": "Foča RS" }, 
    { "value": "5f1703f0c81dd03c240c5e58", "label": "Fojnica" }, 
    { "value": "5f17486dc81dd03c240c5e59", "label": "Gacko" }, 
    { "value": "5f174c9dc81dd03c240c5e5a", "label": "Glamoč" }, 
    { "value": "5f174f20c81dd03c240c5e5b", "label": "Goražde" }, 
    { "value": "5f17517cc81dd03c240c5e5c", "label": "Gornji Vakuf-Uskoplje" }, 
    { "value": "5f1754fdc81dd03c240c5e5d", "label": "Gračanica" }, 
    { "value": "5f175723c81dd03c240c5e5e", "label": "Gradačac" }, 
    { "value": "5f17dc58c81dd03c240c5e5f", "label": "Gradiška" }, 
    { "value": "5f17df3bc81dd03c240c5e60", "label": "Grude" }, 
    { "value": "5f17e2ebc81dd03c240c5e61", "label": "Hadžići" }, 
    { "value": "5f17e48ec81dd03c240c5e62", "label": "Han-Pijesak" }, 
    { "value": "5f181e57c81dd03c240c5e63", "label": "Ilidža" }, 
    { "value": "5f1823e5c81dd03c240c5e64", "label": "Ilijaš" }, 
    { "value": "5f1825b2c81dd03c240c5e65", "label": "Istočna Ilidža" }, 
    { "value": "5f1829f0b901e24158a2896d", "label": "Istočni Drvar" }, 
    { "value": "5f182c7ab901e24158a2896e", "label": "Istočni Mostar" }, 
    { "value": "5f182fcfb901e24158a2896f", "label": "Istočni Stari Grad" }, 
    { "value": "5f18322cb901e24158a28970", "label": "Istočno Novo Sarajevo" }, 
    { "value": "5f183870b901e24158a28971", "label": "Istočno Sarajevo" }, 
    { "value": "5f183aafb901e24158a28972", "label": "Jablanica" }, 
    { "value": "5f183cc6b901e24158a28973", "label": "Jajce" }, 
    { "value": "5f1840a4b901e24158a28974", "label": "Jezero" }, 
    { "value": "5f18428bb901e24158a28975", "label": "Kakanj" }, 
    { "value": "5f184ba7b901e24158a28976", "label": "Kalesija" }, 
    { "value": "5f185517b901e24158a28977", "label": "Kalinovik" }, 
    { "value": "5f1859aeb901e24158a28978", "label": "Kiseljak" }, 
    { "value": "5f185e1bb901e24158a28979", "label": "Kladanj" }, 
    { "value": "5f18660ab901e24158a2897b", "label": "Kneževo" }, 
    { "value": "5f18681ab901e24158a2897c", "label": "Ključ" }, 
    { "value": "5f186fbfb901e24158a2897d", "label": "Konjic" }, 
    { "value": "5f187269b901e24158a2897e", "label": "Kostajnica" }, 
    { "value": "5f1877b4b901e24158a2897f", "label": "Kotor-Varoš" }, 
    { "value": "5f187ae7b901e24158a28980", "label": "Kozarska Dubica" }, 
    { "value": "5f187df6b901e24158a28981", "label": "Kreševo" }, 
    { "value": "5f188302b901e24158a28982", "label": "Krupa na Uni" }, 
    { "value": "5f188578b901e24158a28983", "label": "Kupres FBIH" }, 
    { "value": "5f18887db901e24158a28984", "label": "Kupres RS" }, 
    { "value": "5f19a2f0b901e24158a28985", "label": "Laktaši" }, 
    { "value": "5f19a668b901e24158a28986", "label": "Livno" }, 
    { "value": "5f19abc4b901e24158a28987", "label": "Lopare" }, 
    { "value": "5f19b6b2b901e24158a28988", "label": "Lukavac" }, 
    { "value": "5f19bb1ab901e24158a28989", "label": "Ljubinje" }, 
    { "value": "5f19c009b901e24158a2898a", "label": "Ljubuški" }, 
    { "value": "5f19c58bb901e24158a2898b", "label": "Maglaj" }, 
    { "value": "5f19caf9b901e24158a2898c", "label": "Milići" }, 
    { "value": "5f19d038b901e24158a2898d", "label": "Modriča" }, 
    { "value": "5f19d4fcb901e24158a2898e", "label": "Mostar" }, 
    { "value": "5f19d98db901e24158a2898f", "label": "Mrkonjić Grad" }, 
    { "value": "5f19dc7eb901e24158a28990", "label": "Neum" }, 
    { "value": "5f19df18b901e24158a28991", "label": "Nevesinje" }, 
    { "value": "5f19e4bcb901e24158a28992", "label": "Novi Grad" }, 
    { "value": "5f19e7dab901e24158a28993", "label": "Novi Grad Sarajevo" }, 
    { "value": "5f19ea91b901e24158a28994", "label": "Novi Travnik" }, 
    { "value": "5f19ec96b901e24158a28995", "label": "Novo Goražde" }, 
    { "value": "5f19ef19b901e24158a28996", "label": "Novo Sarajevo" }, 
    { "value": "5f19f2cbb901e24158a28997", "label": "Odžak" }, 
    { "value": "5f19f54cb901e24158a28998", "label": "Olovo" }, 
    { "value": "5f19f734b901e24158a28999", "label": "Orašje" }, 
    { "value": "5f1adc88b901e24158a2899a", "label": "Osmaci" }, 
    { "value": "5f1ade83b901e24158a2899b", "label": "Oštra Luka" }, 
    { "value": "5f1aeb66b901e24158a2899c", "label": "Pale FBIH" }, 
    { "value": "5f1aedb0b901e24158a2899d", "label": "Pale RS" }, 
    { "value": "5f1af088b901e24158a2899e", "label": "Pelagićevo" }, 
    { "value": "5f1afa09b901e24158a2899f", "label": "Petrovac" }, 
    { "value": "5f1bd790b901e24158a289a0", "label": "Petrovo" }, 
    { "value": "5f1bdefab901e24158a289a1", "label": "Posušje" }, 
    { "value": "5f1be364b901e24158a289a2", "label": "Prijedor" }, 
    { "value": "5f1be5e4b901e24158a289a3", "label": "Prnjavor" }, 
    { "value": "5f1be8a8b901e24158a289a4", "label": "Prozor-Rama" }, 
    { "value": "5f1beafbb901e24158a289a5", "label": "Ravno" }, 
    { "value": "5f1bed18b901e24158a289a6", "label": "Ribnik" }, 
    { "value": "5f1beef8b901e24158a289a7", "label": "Rogatica" }, 
    { "value": "5f1bf1cdb901e24158a289a8", "label": "Rudo" }, 
    { "value": "5f1ea9ddb901e24158a289a9", "label": "Sanski Most" }, 
    { "value": "5f1eac95b901e24158a289aa", "label": "Sapna" }, 
    { "value": "5f1eafa1b901e24158a289ab", "label": "Sarajevo" }, 
    { "value": "5f1eb1e6b901e24158a289ac", "label": "Sokolac" }, 
    { "value": "5f1eb457b901e24158a289ad", "label": "Srbac" }, 
    { "value": "5f1eb95db901e24158a289ae", "label": "Srebrenica" }, 
    { "value": "5f1ebbaeb901e24158a289af", "label": "Srebrenik" }, 
    { "value": "5f1ebf9ab901e24158a289b0", "label": "Stanari" }, 
    { "value": "5f1ec7cfb901e24158a289b1", "label": "Stari Grad" }, 
    { "value": "5f1ecbc1b901e24158a289b2", "label": "Stolac" }, 
    { "value": "5f1ece82b901e24158a289b3", "label": "Šamac" }, 
    { "value": "5f1ed3dfb901e24158a289b4", "label": "Šekovići" }, 
    { "value": "5f1ed816b901e24158a289b5", "label": "Šipovo" }, 
    { "value": "5f1eda29b901e24158a289b6", "label": "Široki Brijeg" }, 
    { "value": "5f1edd7db901e24158a289b7", "label": "Teočak" }, 
    { "value": "5f1f2e43b901e24158a289b8", "label": "Teslić" }, 
    { "value": "5f1f30beb901e24158a289b9", "label": "Tešanj" }, 
    { "value": "5f1f33cdb901e24158a289ba", "label": "Tomislavgrad" }, 
    { "value": "5f1f3602b901e24158a289bb", "label": "Travnik" }, 
    { "value": "5f1f37feb901e24158a289bc", "label": "Trebinje" }, 
    { "value": "5f1f39cab901e24158a289bd", "label": "Trnovo FBIH" }, 
    { "value": "5f1f3b6ab901e24158a289be", "label": "Trnovo RS" }, 
    { "value": "5f1f3e2fb901e24158a289bf", "label": "Tuzla" }, 
    { "value": "5f203091b901e24158a289c0", "label": "Ugljevik" }, 
    { "value": "5f2031bcb901e24158a289c1", "label": "Usora" }, 
    { "value": "5f203643b901e24158a289c2", "label": "Vareš" }, 
    { "value": "5f203885b901e24158a289c3", "label": "Velika Kladuša" }, 
    { "value": "5f203b35b901e24158a289c4", "label": "Visoko" }, 
    { "value": "5f203d7cb901e24158a289c5", "label": "Višegrad" }, 
    { "value": "5f203f9db901e24158a289c6", "label": "Vitez" }, 
    { "value": "5f20414fb901e24158a289c7", "label": "Vlasenica" }, 
    { "value": "5f2042dcb901e24158a289c8", "label": "Vogošća" }, 
    { "value": "5f22cffeb901e24158a289c9", "label": "Vukosavlje" }, 
    { "value": "5f22d180b901e24158a289ca", "label": "Zavidovići" }, 
    { "value": "5f22d58eb901e24158a289cb", "label": "Zenica" }, 
    { "value": "5f22da0ab901e24158a289cc", "label": "Zvornik" }, 
    { "value": "5f22dbd8b901e24158a289cd", "label": "Žepče" }, 
    { "value": "5f22dec9b901e24158a289ce", "label": "Živinice" }
];

export const initialMayorFilters = {
    municipalities: [],
    entity: null
}

export const initialMunicipalityFilters = {
    entity: null,
    cantons: []
}